module.exports = __webpack_public_path__ + "static/img/cp2.bb38b127.png";